module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('div', [_c('h2', {
    staticClass: "ui header"
  }, [_vm._v("\n      Hi! Welcome to my personal web page. You'll find my bio and resume in the\n      menu above, as well as a link to my Github page. Thanks for stopping by!\n    ")]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "ui centered image medium",
    attrs: {
      "alt": "Picture of me with cocoa",
      "src": require("../media/Nathan_Allen_Cocoa.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui label"
  }, [_vm._v("\n        Me with some delicious hot cocoa, 2017\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d8b09524","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 33
// module chunks = 0